import React from "react";
import { MenaVstupy, PercentaVstupy } from "../vstupneKomponenty";

export default function InvesticnePoplatkyKarta({
  porovnanieInvesticii,
  aktivnyInvesticnyVariant,
  setAktivnyInvesticnyVariant,
  typPoplatku,
  setTypPoplatku,
  jednorazovyPoplatok,
  setJednorazovyPoplatok,
  rozlozenyPoplatokPercento,
  setRozlozenyPoplatokPercento,
  maxRozlozenyPoplatokZVkladuPercento,
  setMaxRozlozenyPoplatokZVkladuPercento,
  priebeznyPoplatokPercento,
  setPriebeznyPoplatokPercento,
  manazerskyPoplatok,
  setManazerskyPoplatok,
  danovyRezim,
  setDanovyRezim,
  sadzbaDane,
  setSadzbaDane,
  mesacnyVklad,
  cielovaSuma,
  chybaCielovaSumaRozlozenyPoplatok,
  chybaMesacnyVkladPoplatok,
}) {
  const rozlozenyPoplatokCelkom = Math.max(0, Number(cielovaSuma) || 0) * (Math.max(0, Number(rozlozenyPoplatokPercento) || 0) / 100);
  const maxPoplatokZMesiacnehoVkladu = Math.max(0, Number(mesacnyVklad) || 0) * (Math.max(0, Number(maxRozlozenyPoplatokZVkladuPercento) || 0) / 100);
  const pocetSplatok = typPoplatku === "rozlozeny" && rozlozenyPoplatokCelkom > 0 && maxPoplatokZMesiacnehoVkladu > 0
    ? Math.ceil(rozlozenyPoplatokCelkom / maxPoplatokZMesiacnehoVkladu)
    : 0;

  const chybaPolozky = [
    chybaMesacnyVkladPoplatok ? "mes. vklad" : null,
    chybaCielovaSumaRozlozenyPoplatok ? "cieľovú sumu" : null,
  ].filter(Boolean);

  const chybaPoplatkyText = chybaPolozky.length
    ? `Zadaj: ${chybaPolozky.join(", ")}`
    : "";

  const danZapnuta = danovyRezim === "zdanit";

  const nastavDan = (checked) => {
    setDanovyRezim(checked ? "zdanit" : "bezDane");
  };

  return (
    <div className="card-section card-section--invest-poplatky">
      <div className="card-header invest-poplatky-head">
        <h2>Poplatky</h2>

        <div className="applicant-tabs invest-poplatky-tabs">
          <button
            type="button"
            className={`applicant-tab ${aktivnyInvesticnyVariant === 1 ? "is-active" : ""}`}
            onClick={() => setAktivnyInvesticnyVariant(1)}
          >
            Variant 1
          </button>

          {porovnanieInvesticii && (
            <button
              type="button"
              className={`applicant-tab ${aktivnyInvesticnyVariant === 2 ? "is-active" : ""}`}
              onClick={() => setAktivnyInvesticnyVariant(2)}
            >
              Variant 2
            </button>
          )}
        </div>
      </div>

      <div className="form-group invest-poplatky-riadok">
        <div className="form form--m">
          <label className="form_label">Typ poplatku</label>
          <select
            className="form_select"
            value={typPoplatku}
            onChange={(e) => setTypPoplatku(e.target.value)}
          >
            <option value="jednorazovy">Jednorazový</option>
            <option value="rozlozeny">Rozložený</option>
            <option value="priebežny">Priebežný</option>
          </select>
        </div>

        {typPoplatku === "jednorazovy" && (
          <div className="form form--m">
            <label className="form_label">Jednorazový poplatok</label>
            <MenaVstupy
              value={jednorazovyPoplatok}
              onChange={(v) => setJednorazovyPoplatok(Math.min(9999999, Math.max(0, v)))}
              maxDigits={7}
              suffix="€"
              placeholder="0"
            />
          </div>
        )}

        {typPoplatku === "rozlozeny" && (
          <>
            <div className={`form form--m ${chybaCielovaSumaRozlozenyPoplatok ? "form--error" : ""}`}>
              <label className="form_label">Poplatok z CS</label>
              <PercentaVstupy
                value={rozlozenyPoplatokPercento}
                onChange={(v) => setRozlozenyPoplatokPercento(Math.min(5, Math.max(0, v)))}
                maxInt={1}
                placeholder=" "
              />
            </div>

            <div className={`form form--s invest-poplatky-max ${chybaMesacnyVkladPoplatok ? "form--error" : ""}`}>
              <label className="form_label">Max. z vkladu</label>
              <PercentaVstupy
                value={maxRozlozenyPoplatokZVkladuPercento}
                onChange={(v) => setMaxRozlozenyPoplatokZVkladuPercento(Math.min(50, Math.max(0, v)))}
                maxInt={2}
                placeholder=" "
              />
            </div>

            <div className="invest-poplatky-splatky">
              Počet splátok: <strong> {pocetSplatok}</strong>
            </div>
          </>
        )}

        {typPoplatku === "priebežny" && (
          <div className={`form form--m ${chybaMesacnyVkladPoplatok ? "form--error" : ""}`}>
            <label className="form_label">Poplatok z vkladov</label>
            <PercentaVstupy
              value={priebeznyPoplatokPercento}
              onChange={(v) => setPriebeznyPoplatokPercento(Math.min(5, Math.max(0, v)))}
              maxInt={1}
              placeholder=" "
            />
          </div>
        )}
      </div>

      <div className="parametre-divider" />

      <div className="form-group invest-poplatky-spodok">
        <div className="form form--m">
          <label className="form_label">Manažérsky poplatok p.a.</label>
          <PercentaVstupy
            value={manazerskyPoplatok}
            onChange={(v) => setManazerskyPoplatok(Math.min(2.5, Math.max(0, v)))}
            maxInt={1}
            placeholder=" "
          />
        </div>

        <div className="form form--m invest-dan-field">
          <label className="form_label" aria-hidden="true">&nbsp;</label>

          <div className="invest-dan-control">
            <label className="chk invest-dan-check">
              <input
                type="checkbox"
                checked={danZapnuta}
                onChange={(e) => nastavDan(e.target.checked)}
              />
              <span>Daň: </span>
            </label>

            <div className="invest-dan-input">
              <PercentaVstupy
                value={sadzbaDane}
                onChange={(v) => setSadzbaDane(Math.min(40, Math.max(0, v)))}
                maxInt={2}
                placeholder=" "
              />
            </div>
          </div>
        </div>

        <div className="form form--m invest-poplatky-error-wrap">
          <label className="form_label" aria-hidden="true">&nbsp;</label>
          <div className={`inv-hint pp-hint error invest-poplatky-error ${chybaPoplatkyText ? "" : "is-placeholder"}`}>
            {chybaPoplatkyText || " "}
          </div>
        </div>
      </div>
      </div>
  );
}